import script from "./HomeHeroDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeHeroDetails.vue?vue&type=script&setup=true&lang=js"

import "./HomeHeroDetails.vue?vue&type=style&index=0&id=13ff37b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-13ff37b8"]])

export default __exports__